import { render, staticRenderFns } from "./UserCounterItem.vue?vue&type=template&id=b3b56e1a&scoped=true&lang=pug"
import script from "./UserCounterItem.vue?vue&type=script&lang=js"
export * from "./UserCounterItem.vue?vue&type=script&lang=js"
import style0 from "./UserCounterItem.vue?vue&type=style&index=0&id=b3b56e1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3b56e1a",
  null
  
)

export default component.exports